export const FETCHING_USER_LETTERS = 'FETCHING_USER_LETTERS';